import React, { Dispatch, SetStateAction } from 'react';
import { useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { experimentalStyled as styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import Tooltip from '@mui/material/Tooltip';
import './ReturnBar.css';

interface Props {
  title?: string,
  setToggle?: Dispatch<SetStateAction<boolean>>,
  value?: boolean;
  subtitle?: string;  // Optional subtitle to override the date
  onBackClick?: () => void;  // Custom back navigation handler
}

const ReturnBar = (props: Props) => {
  const navigate = useNavigate();

  const notUndefined = (): boolean => {
    return props.onBackClick !== undefined || (props.setToggle !== undefined && props.value !== undefined);
  }
  const setToggle = (): void => {
    if(props.onBackClick) {
      props.onBackClick();
    } else if(props.setToggle !== undefined && props.value !== undefined) {
      props.setToggle(props.value)
    }
  }

  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#ffff',
    ...theme.typography.body2,
    paddingTop: theme.spacing(2.5),
    paddingBottom: theme.spacing(2.5),
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(4),
    marginBottom: theme.spacing(3),
    color: theme.palette.text.primary,
    borderRadius: '8px',
    boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
    border: '1px solid #E0E0E0',
    }));

  const Today = new Date();
  const formattedDate = Today.toLocaleDateString('en-US', { 
    year: 'numeric', 
    month: 'long', 
    day: 'numeric' 
  });

  return (
    <React.Fragment>
      <Item> 
        {
          notUndefined() ?
            <h1 style={{
              fontFamily: 'IBM Plex Sans, sans-serif',
              fontSize: '24px',
              fontWeight: '600',
              color: '#1A237E',
              marginBottom: '4px',
              display: 'inline-flex',
              alignItems: 'center',
              cursor: 'default',
              width: 'fit-content'
            }}>
              <Tooltip title="Back" arrow placement="top">
                <ArrowBackIcon 
                  onClick={() => setToggle()}
                  style={{ 
                    fontSize: '24px', 
                    marginRight: '8px',
                    cursor: 'pointer',
                    transition: 'color 0.2s ease'
                  }}
                  onMouseEnter={(e) => e.currentTarget.style.color = '#0D1642'}
                  onMouseLeave={(e) => e.currentTarget.style.color = '#1A237E'}
                />
              </Tooltip>
              {props.title}
            </h1>
            :
            <h1 style={{
              fontFamily: 'IBM Plex Sans, sans-serif',
              fontSize: '24px',
              fontWeight: '600',
              color: '#1A237E',
              marginBottom: '4px',
              display: 'inline-flex',
              alignItems: 'center',
              cursor: 'default',
              width: 'fit-content'
            }}>
              <Tooltip title="Back" arrow placement="top">
                <ArrowBackIcon 
                  onClick={() => navigate(-1)}
                  style={{ 
                    fontSize: '24px', 
                    marginRight: '8px',
                    cursor: 'pointer',
                    transition: 'color 0.2s ease'
                  }}
                  onMouseEnter={(e) => e.currentTarget.style.color = '#0D1642'}
                  onMouseLeave={(e) => e.currentTarget.style.color = '#1A237E'}
                />
              </Tooltip>
              {props.title}
            </h1>
        }
        <p style={{
          fontFamily: 'IBM Plex Sans, sans-serif',
          fontSize: '14px',
          fontWeight: '400',
          color: '#666',
          margin: 0,
          cursor: 'default'
        }}>{props.subtitle || formattedDate}</p>
      </Item>
    </React.Fragment>
  )
}

export default ReturnBar;